import { css } from "styled-components";

export const baseCSS = css`
  display: inline-block;
  border-radius: ${(props) => props.theme.layout.borderRadius.btn};
  border-style: solid;
  border-width: 1px;
  /*
    The border-color is set to red to ensure that the other CSS styles override
    it so all buttons are the same size.
  */
  border-color: ${(props) => props.theme.color.heartRed};
  padding-top: ${(props) => props.theme.spacing.sm};
  padding-bottom: ${(props) => props.theme.spacing.sm};
  padding-left: ${(props) => props.theme.spacing.xl};
  padding-right: ${(props) => props.theme.spacing.xl};
  font-size: ${(props) => props.theme.typography.typeScale[250]};
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
  &:active,
  &:focus,
  &:hover,
  &:visited {
    text-decoration: none;
  }
`;

export const primaryCSS = css`
  border-color: ${(props) => props.theme.color.buttonBackgroundPrimary};
  background-color: ${(props) => props.theme.color.buttonBackgroundPrimary};
  color: ${(props) => props.theme.color.buttonTextPrimary};
  &:visited {
    border-color: ${(props) => props.theme.color.buttonBackgroundPrimary};
    background-color: ${(props) => props.theme.color.buttonBackgroundPrimary};
    color: ${(props) => props.theme.color.buttonTextPrimary};
  }
  &:active,
  &:focus,
  &:hover {
    border-color: ${(props) => props.theme.color.buttonBorderPrimaryHover};
    background-color: ${(props) =>
      props.theme.color.buttonBackgroundPrimaryHover};
    color: ${(props) => props.theme.color.buttonTextPrimary};
  }
`;

export const secondaryCSS = css`
  border-color: ${(props) => props.theme.color.buttonBorderSecondary};
  background-color: ${(props) => props.theme.color.buttonBackgroundSecondary};
  color: ${(props) => props.theme.color.buttonTextSecondary};
  &:visited {
    border-color: ${(props) => props.theme.color.buttonBorderSecondary};
    background-color: ${(props) => props.theme.color.buttonBackgroundSecondary};
    color: ${(props) => props.theme.color.buttonTextSecondary};
  }
  &:active,
  &:focus,
  &:hover {
    border-color: ${(props) => props.theme.color.buttonBorderSecondaryHover};
    background-color: ${(props) =>
      props.theme.color.buttonBackgroundSecondaryHover};
    color: ${(props) => props.theme.color.buttonTextSecondaryHover};
  }
`;

export const blockCSS = css`
  text-align: center;
  display: block;
`;
